import { createSlice } from "@reduxjs/toolkit";

const initialState = [
   [0,0,0,0,0,0,0,0,0,0],
   [0,0,0,0,0,0,0,0,0,0],
   [0,0,0,0,0,0,0,0,0,0],
   [0,0,0,0,0,0,0,0,0,0],
   [0,0,0,0,0,0,0,0,0,0],
   [0,0,0,0,0,0,0,0,0,0],
   [0,0,0,0,0,0,0,0,0,0]
]

export const statisticsSlice = createSlice({
    name: 'statistics',
    initialState,
    reducers: {
        //update statistics with full dataset
        update: (state, action) => {
            //let's assume we get a full normalized data set and pull entities out of it
            const { entities } = action.payload;
            const { ids } = action.payload;
            //kill status
                state[0].fill(0);
                state[1].fill(0);
                state[2].fill(0);
                state[3].fill(0);
                state[4].fill(0);
                state[5].fill(0);
                state[6].fill(0);
            //calculate table
            ids.forEach(element => {
                state[0][entities[element].answers[0]]+=1;
                state[1][entities[element].answers[1]]+=1;
                state[2][entities[element].answers[2]]+=1;
                state[3][entities[element].answers[3]]+=1;
                state[4][entities[element].answers[4]]+=1;
                state[5][entities[element].answers[5]]+=1;
                state[6][entities[element].answers[6]]+=1;
            });
        },
    }
})

export const { update } = statisticsSlice.actions;

export const selectStatistics = (state) => state.statistics;

export default statisticsSlice.reducer;